/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { withStyles } from '@material-ui/core';
import { bool, number, object } from 'prop-types';
import React from 'react';

const styles = (theme) => ({
    upsellText: {
        color: '#107910',
        fontSize: '14px',
        fontWeight: '600',
        margin: '0 30px',
        [theme.breakpoints.down('600')]: {
            fontSize: '12px',
            margin: '0 10px',
        },
    },
});

const FptSkuUpsellMessage = ({
    classes,
    showUpsellMessage,
    isCurrentSkuAsUpsell,
    priceDifferenceBetweenSkuAndUpsell,
}) => {
    if (isCurrentSkuAsUpsell && showUpsellMessage) {
        if (priceDifferenceBetweenSkuAndUpsell > 0) {
            const skuAndUpsellPrice = parseFloat(priceDifferenceBetweenSkuAndUpsell)?.toFixed(2);
            return (
                <span className={classes.upsellText}>
                    {`Upgrade for only $${skuAndUpsellPrice} more!`}
                </span>
            );
        }
    }
    return null;
};

FptSkuUpsellMessage.propTypes = {
    priceDifferenceBetweenSkuAndUpsell: number.isRequired,
    isCurrentSkuAsUpsell: bool.isRequired,
    classes: object.isRequired,
    showUpsellMessage: bool.isRequired,
};

export default withStyles(styles)(FptSkuUpsellMessage);
